import { useTranslation } from "react-i18next";
import { isFranchiseImpersonationTab } from "../../../utils/franchiseSession";

export default function FranchiseImpersonationBanner() {
  const { t } = useTranslation();

  if (!isFranchiseImpersonationTab()) {
    return null;
  }

  const restaurantId = sessionStorage.getItem("restaurantId");

  return (
    <div
      className="alert alert-info py-2 px-3 mb-0 rounded-0 border-0 d-flex flex-wrap align-items-center justify-content-between gap-2"
      style={{ borderBottom: "1px solid #bee5eb" }}
    >
      <span className="small mb-0">
        <i className="fas fa-sitemap me-2" aria-hidden="true" />
        {t("franchiseImpersonationBanner", {
          restaurantId: restaurantId ? `#${restaurantId.slice(-6)}` : "",
        })}
      </span>
      <span className="small text-muted mb-0">{t("franchiseImpersonationHint")}</span>
    </div>
  );
}
